import type { ListingSide } from '../../b2bSideCopy';
import type { Context } from './types';

/**
 * [MCV-1889] The side of the listing in the wizard. A saved listing says so itself; a new one has
 * the side picked in the "+ New" menu. Anything without a side (every path that predates selling
 * listings) is SEEKING.
 */
export const selectWizardListingSide = (
  context: Pick<Context, 'listing' | 'listingSide'>
): ListingSide =>
  (context.listing?.listingSide ?? context.listingSide) === 'OFFERING' ? 'OFFERING' : 'SEEKING';
